import { Box, Link, Typography } from "@mui/material";
import type { ElementType } from "react";

interface LinkItem {
  label?: string;
  text?: string;
  href?: string;
  onClick?: () => void;
  tagName?: string;
  [key: string]: unknown;
}

interface Props {
  headingText?: string;
  tagName?: string;
  size?: string;
  links?: LinkItem[];
  linkColumnStyle?: string;
  linkStyle?: string;
}

const sizeMap: Record<string, string> = {
  xs: "0.75rem",
  sm: "0.875rem",
  md: "1rem",
  lg: "1.125rem",
  xl: "1.25rem",
};

const SbuxLinkListColumn = ({
  headingText = "",
  tagName = "span",
  size = "xs",
  links,
  linkColumnStyle,
  linkStyle,
}: Props) => {
  const HeadingTag = tagName as ElementType;
  const fontSize = sizeMap[size] || size;

  return (
    <Box className={linkColumnStyle}>
      {headingText && (
        <Typography
          component={HeadingTag}
          sx={{ fontSize, fontWeight: "bold", mb: 1 }}
        >
          {headingText}
        </Typography>
      )}
      <Box component="ul" sx={{ listStyle: "none", p: 0, m: 0 }}>
        {links?.map((link, index) => (
          <Box component="li" key={index} sx={{ mb: 0.5 }}>
            <Link
              href={link.href}
              onClick={link.onClick}
              className={linkStyle}
              sx={{ fontSize, textDecoration: "none" }}
            >
              {link.label || link.text}
            </Link>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default SbuxLinkListColumn;
